import { apiDelete, apiGet, apiPatch, apiPost } from '@starterapp/shared-services/utils';

const getLinkedCard = async (fields) => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsValidation/getLinkedCardDetails?${fields.map(field => 'fields='+field).join('&')}`;
    return await apiGet(url);
}

const getValidationStatus = async (flowType) => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsApplication/validatePOI?type=${flowType}`;
    return await apiGet(url);
}

const getReviewData = async () => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsApplication/review`;
    return await apiGet(url);
}

const postApplication = async (formData) => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsApplication/submit`;
    return await apiPost(url, formData);
}

const postLinking = async (seniorsCardId) => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsLinking/link`;
    return await apiPost(
        url,
        {
            seniorsCardId
        },
        true
    );
}

const deleteCancel = async (inactiveStatusReason) => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsApplication/cancel`;
    return await apiDelete(
        url,
        {
            inactiveStatusReason
        },
        true
    );
}

const patchReplace = async () => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsApplication/replace`;
    return await apiPatch(url);
}

const patchUpgrade = async () => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsApplication/upgrade`;
    return await apiPatch(url);
}

const patchMarketing = async ( receiveNewsletter,notificationMethod,languageSpokenAtHome,pensionStatus,gender,aboriginalOrTorresStraitIslander) => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/seniorsApplication/marketingPreferences`;
    return await apiPatch(
        url,
        {
            receiveNewsletter,
            notificationMethod,
            languageSpokenAtHome,
            pensionStatus,
            gender,
            aboriginalOrTorresStraitIslander
        },
        true
    );
}

export {
    getLinkedCard,
    getValidationStatus,
    getReviewData,
    postApplication,
    postLinking,
    deleteCancel,
    patchReplace,
    patchUpgrade,
    patchMarketing
};
